<div class="mat-elevation-z8"  class="DS_Teamroster">
  <div >
    <img style="height: 48px;" src="../../assets/img/{{this.TeamIcon}}" />ROSTER
  </div>
  <app-text-divider [DividerText]="'GOALTENDERS'"></app-text-divider>
  @for (player of this.getGoalies(); track player) {
    <app-team-roster-player [Player]="player" [GameId]="this.GameId" [TeamId]="this.TeamId"></app-team-roster-player>
  }

  <app-text-divider [DividerText]="'DEFENDERS'"></app-text-divider>
  @for (player of this.getDefenders(); track player) {
    <app-team-roster-player [Player]="player" [GameId]="this.GameId" [TeamId]="this.TeamId"></app-team-roster-player>
  }

  <app-text-divider [DividerText]="'FORWARDS'"></app-text-divider>
  @for (player of this.getForwards(); track player) {
    <app-team-roster-player [Player]="player" [GameId]="this.GameId" [TeamId]="this.TeamId"></app-team-roster-player>
  }

</div>